import extractAttachmentSuggestions from './extractAttachmentSuggestions';
import { AttachButton } from './getAttachmentCommandItems';
import datapoints from '../datapoints';
import { logUsage } from 'owa-analytics';
import { getMRUAttachmentStore } from 'owa-attachment-suggestions';
import ItemId from 'owa-service/lib/contract/ItemId';
import {
    AttachmentSuggestions,
    ClientItem,
    mailStore,
    ReplyWithAttachmentSuggestion,
} from 'owa-mail-store';

export default function logAttachMenuData(
    referenceItemId: ItemId,
    defaultButtonsList: AttachButton[]
) {
    // Get data about attachment suggestions shown.
    const referenceItem: ClientItem = mailStore.items.get(referenceItemId && referenceItemId.Id);
    const replyWithSuggestions: AttachmentSuggestions =
        referenceItem && referenceItem.AttachmentSuggestions;
    const mruSuggestions: ReplyWithAttachmentSuggestion[] = getMRUAttachmentStore().attachments;

    const attachmentSuggestions: ReplyWithAttachmentSuggestion[] = extractAttachmentSuggestions(
        replyWithSuggestions,
        mruSuggestions
    );

    const endpoints: number[] = [];
    const ids: string[] = [];
    const ranks: number[] = [];
    const provenances: string[] = [];
    const fileTypes: string[] = [];

    if (attachmentSuggestions) {
        attachmentSuggestions.forEach((item, index) => {
            endpoints.push(item.Endpoint);
            ids.push(item.Id);
            ranks.push(index);
            provenances.push(item.FileSourceType);
            fileTypes.push(item.FileExtension);
        });
    }

    // Log data now.
    const { name: eventName, customData: customData } = datapoints.AttachButtonMenuOpened.datapoint;
    logUsage(
        eventName,
        customData(
            endpoints,
            ids,
            ranks,
            provenances,
            fileTypes,
            defaultButtonsList,
            true /* isMail */
        )
    );
}
